import React, { FC } from 'react'
import { MicrocopySet } from '../../../../../models/others/microcopy'
import { AllOfficeHolder, OfficeColumn, RegionHolder, TitleHolder } from './style'

//* components
import Typography from '../../../../global/typography'
import OfficeCard from '../officeCard'

type Props = {
  title: string
  officeOrder: any
  microcopy: MicrocopySet | null
  index: number
  activeRegion: number
}

const OfficeRegion: FC<Props> = ({ title, officeOrder, microcopy, index, activeRegion }) => {
  const numberOfOffices = officeOrder?.length || 0

  const regionalOfficesLeft = officeOrder?.map((office: any, index: number) => {
    if (index < (numberOfOffices - 1) * 0.5) {
      const data = { ...office, microcopy }
      return <OfficeCard key={`regionalOfficesLeft_${index}`} {...data} />
    }
  })

  const regionalOfficesRight = officeOrder?.map((office: any, index: number) => {
    if (index >= (numberOfOffices - 1) * 0.5) {
      const data = { ...office, microcopy }
      return <OfficeCard key={`regionalOfficesRight_${index}`} {...data} />
    }
  })

  return (
    <RegionHolder
      data-cy="RegionHolder"
      $isVisible={index + 1 === activeRegion || activeRegion === 0}>
      <TitleHolder>
        {title && (
          <Typography className="RegionTitle" type="header2">
            {title}
          </Typography>
        )}

        {numberOfOffices && (
          <Typography className="RegionCounter" type="header2">
            {`\u00A0(${numberOfOffices})`}
          </Typography>
        )}
      </TitleHolder>

      <AllOfficeHolder>
        {regionalOfficesLeft && <OfficeColumn>{regionalOfficesLeft}</OfficeColumn>}
        {regionalOfficesRight && <OfficeColumn>{regionalOfficesRight}</OfficeColumn>}
      </AllOfficeHolder>
    </RegionHolder>
  )
}

export default OfficeRegion
